import { useQuery, QueryResult, QueryOptions } from '@apollo/client';
// Api
import { GET_STREAM } from 'api/streams/queries';
// Types
import { GetStream, GetStreamVariables } from 'api/streams/types/GetStream';

type BasicQueryOptions = Omit<QueryOptions, 'query' | 'variables'>;

type UseGetStreamOptions = {
  options?: BasicQueryOptions;
  variables: GetStreamVariables;
  skip?: boolean;
};

export const useGetStream = (
  options: UseGetStreamOptions
): QueryResult<GetStream, GetStreamVariables> => {
  return useQuery<GetStream, GetStreamVariables>(GET_STREAM, {
    variables: {
      ...options.variables,
    },
    skip: options?.skip,
    ...options?.options,
  });
};
